import React, { useEffect, useState } from "react";
import Dash from "../assets/Dash.jpg";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { makeAuthenticatedRequest } from "../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { AxiosError } from "../components/sessionexpiry";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Todaypayouts, LastfunloadHistry } from "../redux/DashbordSlice"; // Corrected import
import { Link } from "react-router-dom";
import { CheckCircle, Clock } from "lucide-react"; // Lucide icons

const Dashboard = ({ isSidebarCollapsed, isMobile }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = useState(null);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const Todaypayoutsdetailes = useSelector((state) => state.Dashboard.today);
  const fund_history = useSelector((state) => state.Dashboard.fundloads);

  const [profileData, setProfileData] = useState({
    payout_balance: "0.00",
    virtual_account_no: "000000000000",
  });

  const [accountStatus, setAccountStatus] = useState("pending");
  const [kycStatus, setKycStatus] = useState(0);

  const fetchAccountStatus = async () => {
    try {
      const requestData = JSON.stringify({
        Dname: "merchant",
        Tname: "kycs",
        Cname: ["activate_status"],
        Where: [
          {
            column: "user_id",
            operator: "=",
            value: user_id,
          },
        ],
        Limit: "1",
        Offset: "0",
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );

      console.log(requestData);
      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);

      if (jsonArray.length > 0) {
        setAccountStatus(
          jsonArray[1].activate_status === "2" ? "active" : "pending"
        );
        console.log("Account Status:", jsonArray[0].activate_status);
        console.log("Account Status:");

        //logger("Account Status:", jsonArray[0].status);
      }
    } catch (err) {
      setError(err.message);
      AxiosError(navigate, err);
      //console.log("Account Status:", jsonArray[0].status);
      console.log("Account Status:");
    }
  };

  const fundloads = async () => {
    const dateOnly = new Date().toISOString().slice(0, 10);

    try {
      const requestData = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "fund_history",
        Cname: [
          "mid",
          "amount",
          "reference",
          "open_balance",
          "close_balance",
          "status",
          "created_at",
        ],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
        ],
        Order: { id: "desc" },
        Limit: "5",
        Offset: "0",
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );

      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);

      dispatch(LastfunloadHistry(jsonArray)); // Pass the entire response
    } catch (err) {
      setError(err.message);
      AxiosError(navigate, err);
    }
  };

  useEffect(() => {
    const payout_balance = async () => {
      try {
        const requestData = JSON.stringify({
          Dname: "flipopay_payouts",
          Tname: "merchants m",
          Cname: ["payout_balance", "virtual_account_no"],
          Where: [
            {
              column: "m.mid",
              operator: "=",
              value: user_id,
            },
          ],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );

        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        if (jsonArray.length > 1) {
          setProfileData({
            payout_balance: jsonArray[1].payout_balance || "0.00",
            virtual_account_no:
              jsonArray[1].virtual_account_no || "000000000000",
          });
        }
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };
    payout_balance();

    const todatpayout = async () => {
      const dateOnly = new Date().toISOString().slice(0, 10);

      try {
        const requestData = JSON.stringify({
          Dname: "flipopay_payouts",
          Tname: "payout",
          Cname: ["response", "count(*)", "sum(amount)"],
          Where: [
            {
              column: "mid",
              operator: "=",
              value: user_id,
            },
            {
              column: "date(created_at)",
              operator: "=",
              value: dateOnly,
            },
          ],
          GroupBy: ["response"],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate
        );

        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        dispatch(Todaypayouts(jsonArray)); // Pass the entire response
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };
    todatpayout();
    fundloads();
    fetchAccountStatus();
  }, [dispatch, user_id, navigate]);

  const success =
    Todaypayoutsdetailes && Todaypayoutsdetailes.length > 0
      ? Todaypayoutsdetailes.filter((item) => item.response === "PROCESSED")
      : [];
  const pending =
    Todaypayoutsdetailes && Todaypayoutsdetailes.length > 0
      ? Todaypayoutsdetailes.filter((item) => item.response === "PENDING")
      : [];

  const fundLoadHistory =
    fund_history && fund_history.length > 0 ? fund_history : [];

  const handleHeaderViewClick = () => {
    navigate(`/Fundload`);
  };

  return (
    <div className={`bg-[#F4F5FA]`}>
      {/* Header & Sidebar */}
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}

      {/* Main Content */}

      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "lg:ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "lg:ml-[270px]"
              : "ml-0"
          }`}
        >
          {/* Main content goes here */}

          {/* Main Content */}

          <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Dashboard</h2>
              {/* <p className="text-sm text-gray-600 mt-1">Manage your account payouts and transactions</p> */}
            </div>
            <nav>
              <ol className="flex items-center space-x-2 text-sm">
                <li>
                  <Link
                    className="flex items-center text-gray-500 hover:text-[#299F1F] transition-colors"
                    to="/dashboard"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                    Home
                  </Link>
                </li>
                <li className="text-gray-400">/</li>
                <li className="font-medium text-gray-800">Dashboard</li>
              </ol>
            </nav>
          </div>

          <div class="mx-auto p-4 md:p-4">
            {/* <!-- Breadcrumb Start --> */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Wallet Balance Card */}
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-6 rounded-2xl shadow-lg text-white h-[250px] relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-400 rounded-full transform translate-x-16 -translate-y-16 opacity-20"></div>
                <div className="relative z-10">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-blue-100 font-medium">
                        Wallet Balance
                      </p>
                      <h2 className="text-3xl font-bold mt-2 flex items-center">
                        <span className="mr-2">
                          &#8377; {profileData.payout_balance}
                        </span>
                        {/* <span className="text-green-300 text-sm bg-green-900 bg-opacity-30 px-2 py-1 rounded-full ml-2 flex items-center">
                          5.2% ▲
                        </span> */}
                      </h2>
                    </div>
                    <div className="bg-white bg-opacity-20 p-3 rounded-xl">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-8 w-8"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="mt-8 flex justify-between items-center">
                    <div>
                      <p className="text-blue-100 text-sm">
                        Virtual Account Number
                      </p>
                      <p className="font-medium">
                        {"*".repeat(
                          Math.max(
                            0,
                            profileData.virtual_account_no?.length - 4
                          )
                        ) + profileData.virtual_account_no?.slice(-4)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Transaction History Card */}
              <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col">
                {/* Card Header */}
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-bold text-gray-800">
                    Today's Payouts
                  </h3>
                  <div className="text-xs text-gray-500">
                    {new Date().toLocaleString("en-US", {
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </div>

                {/* Main Stats */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 flex-grow">
                  {/* Success Count */}
                  <div className="bg-green-50 p-4 rounded-xl flex flex-col items-center justify-center min-w-[120px]">
                    <div className="bg-green-100 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-green-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p className="text-xs text-green-600 font-medium">
                      Success
                    </p>
                    <p className="text-xl font-bold text-gray-800 mt-1 whitespace-nowrap overflow-hidden text-ellipsis">
                      {success?.[0]?.["count(*)"] != null
                        ? success[0]["count(*)"]
                        : 0}
                    </p>
                  </div>

                  {/* Total Amount */}
                  <div className="bg-blue-50 p-4 rounded-xl flex flex-col items-center justify-center min-w-[120px]">
                    <div className="bg-blue-100 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <p className="text-xs text-blue-600 font-medium">Amount</p>
                    <p className="text-sm font-bold text-gray-800 mt-1 whitespace-nowrap overflow-hidden text-ellipsis">
                      ₹{" "}
                      {success?.[0]?.["sum(amount)"] != null
                        ? success[0]["sum(amount)"]
                        : "0.00"}
                    </p>
                  </div>

                  {/* Pending Count */}
                  <div className="bg-orange-50 p-4 rounded-xl flex flex-col items-center justify-center min-w-[120px]">
                    <div className="bg-orange-100 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-orange-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <p className="text-xs text-orange-600 font-medium">
                      Pending
                    </p>
                    <p className="text-xl font-bold text-gray-800 mt-1 whitespace-nowrap overflow-hidden text-ellipsis">
                      {pending?.[0]?.["count(*)"] != null
                        ? pending[0]["count(*)"]
                        : 0}
                    </p>
                  </div>
                </div>
              </div>

              {/* Transaction Limit Card */}
              <div className="bg-gradient-to-br from-purple-600 to-purple-800 p-6 rounded-2xl shadow-lg text-white h-[250px] relative overflow-hidden">
                {/* Decorative background element */}
                <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-purple-400 rounded-full opacity-20"></div>

                <div className="relative z-10 h-full flex flex-col justify-between">
                  {/* Header Section */}
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-purple-100 text-sm font-medium">
                        TRANSACTION LIMIT
                      </p>
                      <h2 className="text-2xl font-bold mt-1">
                        Daily / Monthly
                      </h2>
                    </div>
                    <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Progress Bars Section */}
                  <div className="space-y-5">
                    {/* Daily Limit */}
                    <div>
                      <div className="flex justify-between text-xs mb-1.5">
                        <span>Daily Limit</span>
                        <span className="font-medium">&#8377; 1cr</span>
                      </div>
                      <div className="w-full bg-purple-400 bg-opacity-30 rounded-full h-2"></div>
                    </div>

                    {/* Monthly Limit */}
                    <div>
                      <div className="flex justify-between text-xs mb-1.5">
                        <span>Monthly Limit</span>
                        <span className="font-medium">&#8377; 30cr</span>
                      </div>
                      <div className="w-full bg-purple-400 bg-opacity-30 rounded-full h-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Pending Section */}
            {/* <div className="bg-white p-6 rounded-2xl shadow-md md:flex hidden justify-between items-center w-full mt-4 h-[130px]">
              <div className="flex items-center px-5 sm:px-16 gap-x-10 py-2 w-full">
                <div className="flex-1">
                  <span className="text-xl font-bold block mb-1">
                    Account Status:
                  </span>
                  <span className="text-lg text-gray-700">
                    Your account is currently under review. Once your KYC is
                    verified, it will be activated and you'll gain full access
                    to all services.
                  </span>
                </div>
                <div>
                  <img
                    src={Dash}
                    className="w-40"
                    alt="Dashboard illustration"
                  />
                </div>
              </div>
            </div> */}

            {/* Activated Section */}
            {/* <div className="bg-white p-6 rounded-2xl shadow-md md:flex hidden justify-between items-center w-full mt-4 h-[130px]">
              <div className="flex items-center px-5 sm:px-16 gap-x-10 py-2 w-full">
                <div className="flex-1">
                  <span className="text-xl font-bold block mb-1">
                    Account Status:
                  </span>
                  <span className="text-lg text-gray-700">
                    Your account is active. You now have full access to all
                    available services.
                  </span>
                </div>
                <div>
                  <img
                    src={Dash}
                    className="w-40"
                    alt="Dashboard illustration"
                  />
                </div>
              </div>
            </div> */}

            {/* Account Status Section - Conditionally rendered based on status */}
            {accountStatus === "pending" ? (
              <div className="bg-white p-6 rounded-2xl shadow-md md:flex hidden justify-between items-center w-full mt-4 h-[130px]">
                <div className="flex items-center px-5 sm:px-16 gap-x-10 py-2 w-full">
                  <div className="flex items-center gap-4 flex-1">
                    <div className="bg-yellow-100 p-3 rounded-full">
                      <Clock className="h-6 w-6 text-yellow-600" />
                    </div>
                    <div>
                      <span className="text-xl font-bold block mb-1">
                        Account Status: Pending
                      </span>
                      <span className="text-lg text-gray-700">
                        {kycStatus === 1
                          ? "Your KYC is verified. Your account will be activated shortly."
                          : "Your account is under review. Please complete your KYC to activate your account and gain full access to all services."}
                      </span>
                    </div>
                  </div>
                  <div>
                    <img
                      src={Dash}
                      className="w-40"
                      alt="Dashboard illustration"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white p-6 rounded-2xl shadow-md md:flex hidden justify-between items-center w-full mt-4 h-[130px]">
                <div className="flex items-center px-5 sm:px-16 gap-x-10 py-2 w-full">
                  <div className="flex items-center gap-4 flex-1">
                    <div className="bg-green-100 p-3 rounded-full">
                      <CheckCircle className="h-6 w-6 text-green-600" />
                    </div>
                    <div>
                      <span className="text-xl font-bold block mb-1">
                        Account Status: Active
                      </span>
                      <span className="text-lg text-gray-700">
                        Your account is fully activated. You now have access to
                        all services.
                      </span>
                    </div>
                  </div>
                  <div>
                    <img
                      src={Dash}
                      className="w-40"
                      alt="Dashboard illustration"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="lg:flex gap-5">
              {/* Fund Load History Section */}
              <div className="bg-white p-6 rounded-2xl shadow-md h-[350px] w-full mt-5 overflow-y-auto">
                {/* Header with View Button */}
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-semibold text-gray-700">
                    Fund Load History
                  </h2>
                  <button
                    className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-1.5 px-4 rounded-lg"
                    onClick={handleHeaderViewClick} // Define this in your component
                  >
                    View
                  </button>
                </div>

                <hr className="mb-4" />

                {/* Table Content */}
                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm text-gray-700 text-center">
                    <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                      <tr>
                        <th className="px-3 py-2">S.No</th>
                        <th className="px-3 py-2">Created On</th>
                        <th className="px-3 py-2">UTR</th>
                        <th className="px-3 py-2">Amount</th>
                        <th className="px-3 py-2">Open Balance</th>
                        <th className="px-3 py-2">Close Balance</th>
                        <th className="px-3 py-2">Status</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 text-center">
                      {fundLoadHistory.slice(1).length > 0 ? (
                        fundLoadHistory.slice(1).map((fund, index) => (
                          <tr
                            key={`fund-${index}-${fund.reference}`}
                            className="hover:bg-gray-50"
                          >
                            <td className="px-3 py-2">{index + 1}</td>
                            <td className="px-3 py-2">{fund.created_at}</td>
                            <td className="px-3 py-2">{fund.reference}</td>
                            <td
                              className={`px-3 py-2 font-semibold ${
                                fund.status === "3"
                                  ? "text-red-600"
                                  : "text-blue-600"
                              }`}
                            >
                              {fund.status === "3" ? "-" : "+"}
                              {fund.amount}
                            </td>

                            <td className="px-3 py-2">{fund.open_balance}</td>
                            <td className="px-3 py-2">{fund.close_balance}</td>
                            <td className="px-3 py-2">
                              <span
                                className={`text-xs font-medium px-2 py-1 rounded
                                  ${
                                    fund.status === "1"
                                      ? "bg-green-100 text-green-700"
                                      : fund.status === "2"
                                      ? "bg-blue-100 text-blue-700"
                                      : fund.status === "4"
                                      ? "bg-purple-100 text-purple-700"
                                      : "bg-red-100 text-red-700"
                                  }`}
                              >
                                {fund.status === "1"
                                  ? "Success"
                                  : fund.status === "2"
                                  ? "Internal Fund"
                                  : fund.status === "4"
                                  ? "Refund"
                                  : "Deduction"}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            className="text-center py-4 text-gray-500"
                          >
                            No fund load history found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <hr className="mt-4" />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
